module.exports = __webpack_public_path__ + "img/admin.078ee9a7.jpg";